import { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { APP_URLS } from '../routes/paths';
import { useAuthContext } from './auth-provider';

export const AuthOutlet = () => {
  const { isLoggedIn } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [renderOutlet, setRenderOutlet] = useState(false);

  useAsyncEffect(async () => {
    if (!(await isLoggedIn())) {
      // Build the redirect
      const { pathname, search } = location;
      const redirect = `${pathname}${search}`;
      navigate(APP_URLS.login(redirect));
    } else {
      setRenderOutlet(true);
    }
  });

  if (!renderOutlet) {
    return null;
  }

  return <Outlet />;
};
